import { Map } from 'immutable'
import {
  SET_CS_PARAM,
  SET_CS_PARAM_OFFSET_LIMIT,
  SET_CS_PARAM_ERROR,
  CLEAR_CS_PARAM_ERROR,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_CS_PARAM: {
      const {
        storeKey, data, total, processing,
      } = payload
      return state.update(
        storeKey,
        Map(),
        (branch) => branch.merge(Map({ data, total, processing })),
      )
    }
    case SET_CS_PARAM_OFFSET_LIMIT: {
      const {
        storeKey, offset, limit, processing,
      } = payload
      return state.update(
        storeKey,
        Map(),
        (branch) => branch.merge(Map({ offset, limit, processing })),
      )
    }
    case SET_CS_PARAM_ERROR: {
      const { err } = payload
      const newState = state.set('error', err)
      return newState
    }
    case CLEAR_CS_PARAM_ERROR: {
      return state.delete('error')
    }
    default:
      return state
  }
}
